<template lang="pug">
  v-dialog(v-model="showConfirmDialog"
    persistent
    max-width="400" )
    v-snackbar( v-model="snackbar" color="red darken-2" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card.d-flex.flex-column
      v-alert.text-center.mb-0.break-line( v-if="ordersExists && !verificationInProgress"
        color="red" text ) {{ $t('confirmDialog.ordersExists') }}
      v-card-text.text-center.mt-3.font-weight-bold( v-if="!verificationInProgress" ) {{ $t('confirmDialog.confirmDialogTitle') }} {{ title + "?" }}
      v-card-actions.justify-end(v-if="!verificationInProgress")
        v-btn( @click="onCloseButtonClick" text color="primary" :disabled="deleteInProgress") {{ $t('buttons.noButtonLabel') }}
        v-btn( :loading="deleteInProgress"
          :disabled="deleteInProgress"
          @click="onDeleteButtonClick"
          color="primary" ) {{ $t('buttons.yesButtonLabel') }}
      v-skeleton-loader.ma-3(v-else type="list-item-three-line, actions")
</template>

<script lang="ts">

import Vue from "vue"
import {Component, Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {DELETE_CALENDAR_EVENT_FOR_DAY, FETCH_NUMBER_OF_ORDERS} from "@/store/action-types";
import {DeleteCalendarEventPayload, NumberOfOrdersPayload, NumberOfOrdersWithCancelTokenPayload} from "@/types/payload";
import {NumberOfOrdersResponse} from "@/types/service-response";
import moment from "moment/moment";
import axios from "axios";


@Component({})

export default class ConfirmDialog extends Vue {

  @Prop({type: Boolean, default: false}) showConfirmDialog!: boolean
  @Prop({type: String, default: ''}) pickedEventStart!: ''
  @Prop({type: String, default: ''}) pickedEventId!: ''

  @Action(FETCH_NUMBER_OF_ORDERS) fetchNumberOfOrders!: { (payload: NumberOfOrdersWithCancelTokenPayload): Promise<NumberOfOrdersResponse> }
  @Action(DELETE_CALENDAR_EVENT_FOR_DAY) deleteCalendarEventForDay!: { (payload: DeleteCalendarEventPayload): Promise<void> }

  private verificationInProgress: boolean = false

  private canceledCount: number = 0
  private ordersExists: boolean = false

  private deleteInProgress: boolean = false
  private wasDeleted: boolean = false

  private snackbar: boolean = false
  private snackbarColor: string = ''
  private snackBarMessage: string = ''

  get title() {
    return moment(this.pickedEventStart).format('DD.MM.YYYY')
  }

  async fetchOrdersData(): Promise<void> {

    let pickedDates: string[] = []
    if (this.pickedEventStart) {
      pickedDates.push(this.pickedEventStart)
    }

    let pickedDatesPayload: NumberOfOrdersPayload = {
      dates: pickedDates
    }

    let payload: NumberOfOrdersWithCancelTokenPayload = {
      payload: pickedDatesPayload,
      cancelToken: axios.CancelToken.source()
    }

    try {
      this.verificationInProgress = true
      let response = await this.fetchNumberOfOrders(payload)
      this.canceledCount = response.canceledCount
      if (this.canceledCount > 0) {
        this.ordersExists = true
      }
    } catch (e) {
      this.snackbar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = (e as Error).message, this.$t('errors.fetchDataError').toString()
    } finally {
      this.verificationInProgress = false
    }
  }

  async deleteEvent(): Promise<void> {

    this.deleteInProgress = true

    let payload: DeleteCalendarEventPayload = {
      id: this.pickedEventId
    }

    try {
      await this.deleteCalendarEventForDay(payload)
      this.wasDeleted = true
      this.closeDialog()
    } catch (e) {
      this.snackbar = true
      this.snackbarColor = 'error'
      this.snackBarMessage = this.$t('errors.deleteDataError').toString()
    } finally {
      this.deleteInProgress = false
    }
  }

  onDeleteButtonClick(): void {
    this.deleteEvent()
  }

  onCloseButtonClick(): void {
    this.closeDialog()
  }

  closeDialog(): void {
    this.$emit('closeConfirmDialog', this.wasDeleted)
  }

  mounted(): void {
    this.fetchOrdersData()
  }

}
</script>

<style lang="stylus" scoped>

  .break-line {
    white-space: pre;
  }

</style>